// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-light .comments img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.theme-light .comments .write {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin: 20px 0px;
}
.theme-light .comments .write input {
  flex: 5 1;
  padding: 10px;
  border: 1px solid lightgray;
  background-color: transparent;
  color: #000;
}
.theme-light .comments .write button {
  border: none;
  background-color: #5271ff;
  color: white;
  padding: 10px;
  cursor: pointer;
  border-radius: 3px;
}
.theme-light .comments .comment {
  margin: 30px 0px;
  display: flex;
  justify-content: space-between;
  gap: 20px;
}
.theme-light .comments .comment .info {
  flex: 5 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
  align-items: flex-start;
}
.theme-light .comments .comment .info span {
  font-weight: 500;
}
.theme-light .comments .comment .info p {
  color: #555;
}
.theme-light .comments .comment .date {
  flex: 1 1;
  align-self: center;
  color: gray;
  font-size: 12px;
}
.theme-dark .comments img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.theme-dark .comments .write {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin: 20px 0px;
}
.theme-dark .comments .write input {
  flex: 5 1;
  padding: 10px;
  border: 1px solid #444;
  background-color: transparent;
  color: #fffef9;
}
.theme-dark .comments .write button {
  border: none;
  background-color: #5271ff;
  color: white;
  padding: 10px;
  cursor: pointer;
  border-radius: 3px;
}
.theme-dark .comments .comment {
  margin: 30px 0px;
  display: flex;
  justify-content: space-between;
  gap: 20px;
}
.theme-dark .comments .comment .info {
  flex: 5 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
  align-items: flex-start;
}
.theme-dark .comments .comment .info span {
  font-weight: 500;
}
.theme-dark .comments .comment .info p {
  color: #d1d0c9;
}
.theme-dark .comments .comment .date {
  flex: 1 1;
  align-self: center;
  color: gray;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/comments/comments.scss"],"names":[],"mappings":"AAII;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAHN;AAMI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;AAJN;AAMM;EACE,SAAA;EACA,aAAA;EACA,2BAAA;EACA,6BAAA;EACA,WAAA;AAJR;AAOM;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;AALR;AASI;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;AAPN;AASM;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,uBAAA;AAPR;AASQ;EACE,gBAAA;AAPV;AAUQ;EACE,WAAA;AARV;AAYM;EACE,SAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AAVR;AAhDI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAkDN;AA/CI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;AAiDN;AA/CM;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,cAAA;AAiDR;AA9CM;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;AAgDR;AA5CI;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;AA8CN;AA5CM;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,uBAAA;AA8CR;AA5CQ;EACE,gBAAA;AA8CV;AA3CQ;EACE,cAAA;AA6CV;AAzCM;EACE,SAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AA2CR","sourcesContent":["@import \"../../style.scss\";\n\n.comments {\n  @include themify($themes) {\n    img {\n      width: 40px;\n      height: 40px;\n      border-radius: 50%;\n      object-fit: cover;\n    }\n\n    .write{\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 20px;\n      margin: 20px 0px;\n\n      input{\n        flex:5;\n        padding: 10px;\n        border: 1px solid themed(\"border\");\n        background-color: transparent;\n        color: themed(\"textColor\");\n      }\n\n      button{\n        border: none;\n        background-color: #5271ff;\n        color: white;\n        padding: 10px;\n        cursor: pointer;\n        border-radius: 3px;\n      }\n    }\n\n    .comment {\n      margin: 30px 0px;\n      display: flex;\n      justify-content: space-between;\n      gap: 20px;\n\n      .info {\n        flex:5;\n        display: flex;\n        flex-direction: column;\n        gap: 3px;\n        align-items: flex-start;\n\n        span {\n          font-weight: 500;\n        }\n\n        p{\n          color:themed(\"textColorSoft\")\n        }\n      }\n\n      .date{\n        flex:1;\n        align-self: center;\n        color: gray;\n        font-size: 12px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
